export const formatTimeString = (timeString) => {

    if (!timeString) return null;  
    
    const fornattedTime = new Date(timeString);
    return fornattedTime.toLocaleTimeString('en-GB', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  }